module.exports = __webpack_public_path__ + "static/media/feedback-shared.7d16b712.svg";